import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';
import * as templateActions from '../../../template/redux/actions';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import SocketIOTemplateForm from './SocketIOTemplateForm';
export class SocketIOActionForm extends Component {
  componentDidMount = () => {
    const { projectId, actions, version } = this.props;
    actions.fetchAllSocketIoTemplate({ projectId, version });
  };

  handleTemplatesRules = (values) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    let templatesRules = eventAction.parameters.find((param) => {
      return param.name === 'templatesRules';
    });
    if (templatesRules) {
      let existingIndex = templatesRules.value.findIndex((e) => e.templateId === values.templateId);
      if (existingIndex < 0) {
        templatesRules.value = [...templatesRules.value, values];
      } else {
        templatesRules.value[existingIndex] = values;
      }
    } else {
      templatesRules = { name: 'templatesRules', value: [values], type: 'array' };
      eventAction.parameters = [...eventAction.parameters, templatesRules];
    }
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };

  deleteTemplateRule = (templateId) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    let templatesRules = eventAction.parameters.find((param) => {
      return param.name === 'templatesRules';
    });
    templatesRules.value = templatesRules.value.filter((e) => e.templateId !== templateId);
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };

  closeAllOpenPopup = () => {
    this.props.actions.closeActionFormModal();
  };

  getTemplateName = (templateId) => {
    const { socketIoTemplates } = this.props.template;
    const selectedTemplate = socketIoTemplates
      ? socketIoTemplates.find((e) => e.uuid === templateId)
      : null;
    return selectedTemplate ? selectedTemplate.name : '';
  };

  showTemplateRuleDetails = (templateRule) => {
    const { events, template, projectId, version } = this.props;
    return templateRule ? (
      <Fragment key={templateRule.templateId}>
        <Accordion allowZeroExpanded>
          <AccordionItem key={templateRule.templateId}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <i className="wb webconnect-chat-left-text"></i>{' '}
                <strong>{this.getTemplateName(templateRule.templateId)}</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <SocketIOTemplateForm
                socketIoTemplateRule={templateRule}
                handleSubmit={this.handleTemplatesRules}
                collections={events.collections}
                projectDetail={events.projectDetail}
                socketIoTemplates={template.socketIoTemplates}
                projectId={projectId}
                version={version}
                closeAllOpenPopup={this.closeAllOpenPopup}
              >
                <div className="row">
                  <div className="col-12">
                    <div className="text-right">
                      <button
                        type="button"
                        className="btn btn-theme-delete btn-md"
                        onClick={() => this.deleteTemplateRule(templateRule.templateId)}
                      >
                        <i className="wb webconnect-trash-regular"></i> Delete
                      </button>
                      &nbsp;
                      <button type="submit" className="btn btn-theme-submit btn-md">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Update
                      </button>
                    </div>
                  </div>
                </div>
              </SocketIOTemplateForm>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </Fragment>
    ) : (
      ''
    );
  };

  render() {
    const { eventAction, events, template, projectId, version } = this.props;
    const { socketIoTemplates } = template;
    let templatesRules = eventAction.parameters.find((param) => {
      return param.name === 'templatesRules';
    });
    return (
      <Fragment>
        <Accordion allowZeroExpanded>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <i className="wb webconnect-chat-left-text"></i>{' '}
                <strong>New Socket IO Template</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <SocketIOTemplateForm
                socketIoTemplateRule={{
                  templateId: '',
                  notificationType: '',
                  userIdFields: '',
                  getItemIdFrom: '',
                }}
                handleSubmit={this.handleTemplatesRules}
                collections={events.collections}
                projectDetail={events.projectDetail}
                socketIoTemplates={socketIoTemplates}
                projectId={projectId}
                version={version}
                closeAllOpenPopup={this.closeAllOpenPopup}
              >
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      type="reset"
                      onClick={() => this.props.hideModal()}
                      className="btn btn-outline-secondary btn-sm"
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button type="submit" className="btn btn-theme-submit btn-sm">
                      <i className="wb webconnect-save-regular"></i>&nbsp;Save
                      <CustomLoader loading={this.props.showLoaderForAction} />
                    </button>
                  </div>
                </div>
              </SocketIOTemplateForm>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>

        {templatesRules && templatesRules.value && templatesRules.value.length > 0
          ? templatesRules.value.map((rule) => this.showTemplateRuleDetails(rule))
          : ''}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    template: state.template,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...templateActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SocketIOActionForm);
